import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import { Content, Layout, LoadingIndicator } from '@eluve/components';

import { CreatePromptTemplatePage } from './CreatePromptTemplatePage';

export const PromptsPage = () => {
  return (
    <Suspense fallback={<LoadingIndicator size="xl" />}>
      <Layout type="simple">
        <Helmet>
          <title>Prompts | Eluve</title>
        </Helmet>
        <Content padded>
          <div className="p-3 pt-0 pb-6">
            <CreatePromptTemplatePage onDoneNavigateTo="/" />
          </div>
        </Content>
      </Layout>
    </Suspense>
  );
};
